module.exports = __webpack_public_path__ + "img/evacuvation-sq.fb6b5ab1.svg";